import { useMemo } from "react";

import type { TabRoute, UserAccessContext, UserWithPermissions } from "@/@types/tab-navigation";
import { STORAGE_KEYS } from "@/constants/storage-keys";
import { useAuthData } from "@/context/auth-data-provider";
import { buildAccessContext, hasRouteAccess } from "@/shared/handle-permission";
import { getUserFromLocalStorage } from "@/utils/getUserFromLocalStorage";

export const resolveVisibleTabs = (tabs: TabRoute[], context: UserAccessContext): TabRoute[] =>
  tabs.filter((tab: TabRoute) => hasRouteAccess(tab, context));

export const useVisibleTabs = (tabs: TabRoute[]): TabRoute[] => {
  const authData: ReturnType<typeof useAuthData> = useAuthData();
  const user: UserWithPermissions | null = authData?.user ?? getUserFromLocalStorage();
  const module: string | null =
    authData?.currentModule ?? localStorage.getItem(STORAGE_KEYS.MODULE);

  return useMemo(
    (): TabRoute[] => resolveVisibleTabs(tabs, buildAccessContext(user, module)),
    [tabs, user, module],
  );
};
